module.exports = {
          srcSet: __webpack_public_path__ + "9bced7067a8a8f3ebaaec20c1d53e936-64.png"+" 64w",
          images:[ {path: __webpack_public_path__ + "9bced7067a8a8f3ebaaec20c1d53e936-64.png",width: 64,height: 65}],
          src: __webpack_public_path__ + "9bced7067a8a8f3ebaaec20c1d53e936-64.png",
          toString:function(){return __webpack_public_path__ + "9bced7067a8a8f3ebaaec20c1d53e936-64.png"},
          
          width: 64,
          height: 65
        }